// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"4fc53dd4","848":"4fc53dd4","884":"ca7de884","967":"4fc53dd4","971":"4fc53dd4"}[chunkId] + ".chunk.css";
};